import { Component, Input } from '@angular/core';
import { StudentPerformanceDto } from '@whetstoneeducation/hero-common';

@Component({
  selector: 'app-student-low-performers',
  templateUrl: './student-low-performers.component.html',
  styleUrls: ['./student-low-performers.component.scss']
})
export class StudentLowPerformersComponent {
  @Input() public lowPerformers: StudentPerformanceDto[];
}
